const INGRESO = 'ING'
const EGRESO = 'EGR'

const __dictionary = {
  [INGRESO]: {
    id: INGRESO,
    nombre: 'INGRESO'
  },
  [EGRESO]: {
    id: EGRESO,
    nombre: 'EGRESO'
  }
}

const __array = [__dictionary[INGRESO], __dictionary[EGRESO]]

export default Object.freeze({
  INGRESO,
  EGRESO,
  __dictionary,
  __array
})
